import { compose, createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers/index';
import ReduxThunk from 'redux-thunk';
// search
import searchActions from './actions/search';

let reduxStore;

const getComposer = () => {
    const middlewares = [ReduxThunk];
    let composeEnhancers = [];
    if (
        (process && process.env && process.env.NODE_ENV !== 'production') ||
        window.location.search.includes('debug-redux')
    ) {
        composeEnhancers =
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    } else {
        composeEnhancers = compose;
    }
    const appliedMiddleware = applyMiddleware(...middlewares);
    return composeEnhancers(appliedMiddleware);
};

const enableWebPackHotModuleReplacementForReducers = (module, store) => {
    if (!module.hot) {
        return;
    }
    module.hot.accept('./reducers/index', () => {
        const nextRootReducer = require('./reducers/index');
        store.replaceReducer(nextRootReducer);
    });
};

function configureStore(browserHistory) {
    reduxStore = createStore(rootReducer, getComposer(browserHistory));
    enableWebPackHotModuleReplacementForReducers(module, reduxStore);
    return reduxStore;
}

const globalStore = () => (reduxStore ? reduxStore : configureStore());

const store = globalStore();
const { initData } = store.getState();

/**
 *  We hydrate the store with discover results from initData
 * this will be dispatched before any rendering to reduce the time from first byte to first render.
 */
if (initData && 'discoverResponse' in initData) {
    store.dispatch(
        searchActions.receiveSearchResults(initData.discoverResponse)
    );
}

export default store;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/configure-store.js